import React, { useEffect, useState } from "react";
import "./horizontalMenu.css";
import { FaSignOutAlt } from "react-icons/fa";
import { FiHome } from "react-icons/fi";
import { SlCalender } from "react-icons/sl";
import { FaTrophy } from "react-icons/fa";
import { IoPersonOutline } from "react-icons/io5";
import { Link } from "react-router-dom";
import axiosInstance from "../utils/axiosInstance";
import { useNavigate } from "react-router-dom";
import logout from "../utils/logout";

function HorizontalMenu() {
  const [username1, setUsername] = useState("");
  const [hovered, setHovered] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    axiosInstance
      .get("/users/current")
      .then((response) =>
        response.data?.username ? setUsername(response.data.username) : ""
      )
      .catch((error) => {
        if (error.response?.status === 401 || error.response?.status === 400) {
          navigate("/login");
        }
      });
  });

  const styles = { paddingLeft: "10px" };
  return (
    <div className="menu">
      <Link to="/home">
        <FiHome />
        <div style={styles}>Home</div>
      </Link>
      <Link to="/mychallenges">
        <SlCalender />
        <div style={styles}>My Challenges</div>
      </Link>

      <Link to="/trophies">
        <FaTrophy />
        <div style={styles}>Trophies</div>
      </Link>
      <Link to={`/user/${username1}`}>
        <IoPersonOutline />
        <div style={styles}>Profile</div>
      </Link>
      <span class="brandname">Kluch Daily</span>

      {/* User Section (added) */}
      <div className="user-section">
        <span className="username">{username1}</span>
        <span style={{ marginLeft: '4px', marginRight: '2px', fontSize: '10px', color: '#d3d3d3' }}>Log Out</span>
        <FaSignOutAlt
          onClick={logout}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
          style={{
            color: hovered ? "red" : "black", // Change color on hover
            cursor: "pointer",
            transition: "color 0.3s",
          }}
        />
        {/* <img src="signout-icon.png" alt="Sign Out" className="sign-out-icon" /> */}
      </div>
    </div>
  );
}

export default HorizontalMenu;
